import { api } from '../api';
import { CreateSessionDTO } from '../../dtos/CreateSessionDTO';

type Credentials = {
  mfaToken: string;
};

export const createSession = async (
  dataRequest: CreateSessionDTO,
): Promise<Credentials> => {
  const { data } = await api.post('sessions', {
    ...dataRequest,
  });

  return data;
};
